import { Menu, StudentMenu } from '@/plugins/api'
import moment from 'moment'
import { keyBy, get } from 'lodash'

export default {
  namespaced: true,
  state: {
    loading: false,
    date: moment().toISOString(),
    expandList: [],
    menuListDisplay: [],
  },
  actions: {
    async fetchData({ commit, state }) {
      state.loading = true
      const startWeek = moment(state.date)
        .startOf('week')
        .toISOString()
      const endWeek = moment(state.date)
        .endOf('week')
        .toISOString()
      const menus = await Menu.fetch({ date_gte: startWeek, date_lte: endWeek })
      const studentMenus = await StudentMenu.getStudentMenuCountReportByWeek({ startDate: startWeek, endDate: endWeek })
      const menuObj = keyBy(menus, 'day')
      const expandList = []
      let menuListDisplay = []
      const days = [1, 2, 3, 4, 5, 6, 7]
      for (let i = 0; i < days.length; i++) {
        const day = days[i]
        const currentMenu = menuObj[`${day == 7 ? '0' : day}`]
        const menuCountByDay = studentMenus.find(x => (day === 7 ? x.day === '0' : x.day == day))
        let payload = { commonInfor: true, expanded: false }
        if (currentMenu) {
          payload = { ...currentMenu, ...payload }
          if (payload.day == 0) payload.day = 7
        } else payload['day'] = day
        if (menuCountByDay) {
          payload['selectedMenu1Count'] = menuCountByDay.countMenu1
          payload['selectedMenu2Count'] = menuCountByDay.countMenu2
          payload['date'] = menuCountByDay.date
        } else {
          if (payload.date) payload['date'] = moment(payload.date).format('DD/MM/YYYY')
          else
            payload['date'] = moment(startWeek)
              .isoWeekday(day)
              .format('DD/MM/YYYY')
        }
        menuListDisplay.push(payload)

        const mainDish = {
          day,
          name: 'Món chính',
          menu1List: get(currentMenu, 'firstMainDishes', []),
          menu2List: get(currentMenu, 'secondMainDishes', []),
          expanded: false,
          expandInfo: true,
          type: 'main',
        }
        const sideDish = {
          day,
          name: 'Món phụ',
          menu1List: get(currentMenu, 'firstSideDishes', []),
          menu2List: get(currentMenu, 'secondSideDishes', []),
          expanded: false,
          expandInfo: true,
          type: 'side',
        }
        const action = {
          day,
          name: '',
          expanded: false,
          expandInfo: true,
          type: 'action',
        }
        const viewMenuDetail = {
          day,
          name: '',
          expanded: false,
          expandInfo: true,
          type: 'viewDetail',
        }
        expandList.push(...[mainDish, sideDish, action, viewMenuDetail])
      }
      commit('changeState', {
        expandList,
        menuListDisplay,
      })
      state.loading = false
    },
    setDate({ commit }, date) {
      commit('changeState', { date })
    },
    expandInfo({ commit, state }, day) {
      day = +day
      let menuListDisplay = [...state.menuListDisplay]
      const index = menuListDisplay.filter(m => +m.day < day + 1).length
      const expandInfoMenus = [...state.expandList].filter(m => +m.day === day)
      if (!expandInfoMenus[0].expanded) {
        // add
        const list = expandInfoMenus.map(m => {
          m.expanded = true
          return m
        })

        menuListDisplay.splice(index, 0, ...list)
        menuListDisplay = menuListDisplay.map(m => {
          if (+m.day === day) m.expanded = true
          return m
        })
      } else {
        // remove
        menuListDisplay = menuListDisplay.filter(m => +m.day !== day || m.commonInfor)
        menuListDisplay = menuListDisplay.map(m => {
          if (+m.day === day) m.expanded = false
          return m
        })
        expandInfoMenus.map(m => {
          m.expanded = false
          return m
        })
      }
      commit('changeState', { menuListDisplay })
    },
    createMenu(_, params) {
      return Menu.create(params)
    },
    updateMenu(_, { id, ...params }) {
      return Menu.update(id, params)
    },
  },
  mutations: {},
  getters: {
    startWeek: state => moment(state.date).startOf('week'),
    endWeek: state => moment(state.date).endOf('week'),
  },
}
